import { useAtom } from 'jotai';
import { QueryKeys, urlStateAtom } from './urlState';
import type { UrlState } from './urlState';

// Re-export for convenience
export { QueryKeys, UrlState };

export function useUrlState(): {
    urlState: UrlState;
    updateUrl: (state: UrlState, replace: boolean) => void;
} {
    const [urlState, updateUrl] = useAtom(urlStateAtom);

    return {
        urlState,
        updateUrl,
    };
}
